import * as React from 'react';

const SvgArrow = props => (
  <svg
    height={13.325}
    viewBox="0 0 14.044 13.325"
    width={14.044}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      data-name="Group 4"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
    >
      <path
        d="M1 6.603h11.424"
        data-name="Path 4"
      />
      <path
        d="m7.461 11.911 5.179-5.323-5.179-5.175"
        data-name="Path 5"
      />
    </g>
  </svg>
);

export default SvgArrow;

